import { render, staticRenderFns } from "./mediaPartners.vue?vue&type=template&id=5a4bcc2e&scoped=true&"
import script from "./mediaPartners.vue?vue&type=script&lang=js&"
export * from "./mediaPartners.vue?vue&type=script&lang=js&"
import style0 from "./mediaPartners.vue?vue&type=style&index=0&id=5a4bcc2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4bcc2e",
  null
  
)

export default component.exports